import React, { useEffect, useState } from "react";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import axios from "axios";
import { alert } from "src/services/alert";
import MyPagination from "../common/MyPagination";
import { IMG_BASE_URL } from "src/config/constants";
import { Box } from "@mui/material";
import { asyncRequest } from "src/services/network";

function ArticlePages({ onSelect }) {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [filter, setFilter] = useState({
    page: 0,
    size: 10,
    search: "",
  });

  useEffect(() => {
    getItems();
  }, [filter]);

  async function getItems() {
    const { data, count } = await asyncRequest({
      path: "/article/short",
      data: filter,
    });

    setItems(data);
    setTotal(count);
  }

  function handleItemCLick(row) {
    onSelect(`/pages/article-detail/article-detail?id=${row.id}`);
  }

  const handlePageChange = (event, value) => {
    const newPage = value - 1;
    if (newPage === filter.page) return;
    setFilter({
      ...filter,
      page: newPage,
    });
  };

  return (
    <Box sx={{ flex: 1, overflow: "auto" }}>
      <TableContainer>
        <Table sx={{ minWidth: 500 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>标题</TableCell>
              <TableCell align="left">预览图</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((row) => (
              <TableRow key={row.id} sx={{ "&:last-child td, &:last-child th": { border: 0 }, cursor: "pointer" }} onClick={() => handleItemCLick(row)}>
                <TableCell align="left">{row.title}</TableCell>
                <TableCell align="left">
                  <img src={`${IMG_BASE_URL}${row.cover}`} style={{ maxHeight: 40 }} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <MyPagination total={total} page={filter.page} size={filter.size} onChange={handlePageChange} />
    </Box>
  );
}

export default ArticlePages;
